import { render, staticRenderFns } from "./CourseCategoryDetails.vue?vue&type=template&id=7cb56b84&"
import script from "./CourseCategoryDetails.vue?vue&type=script&lang=js&"
export * from "./CourseCategoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports